import React from 'react'

import { Heading } from '@/components/ui/heading'
import { cn } from '@/lib/utils'

type Props = Omit<React.ComponentProps<typeof Heading>, 'size'>

const CardHeading: React.FC<Props> = ({ className, style, ...props }) => (
  <Heading
    size={4}
    className={cn('font-semibold text-black', className)}
    style={{ fontSize: '19px', ...style }}
    {...props}
  />
)

export default CardHeading
